module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921115649_T.993588a1.jpg";